<div class="flex-vertical gap-32">
  @if (fichiersAControler && fichiersAControler.length) {
    <app-file-status-accordion
      [audience]="mode"
      [files]="fichiersAControler"
      [title]="'À contrôler'"
      [titleColor]="'alert'"
      [checkbox]="checkbox"
      [withValidateAll]="true"
      [backofficeEditable]="isBackofficeEditable"
      (validateAllClicked)="onValidateAllToControlClick()"
      (fileClicked)="onfileClick($event)">
    </app-file-status-accordion>
  }
  @if (fichiersNonConformes && fichiersNonConformes.length) {
    <app-file-status-accordion
      [audience]="mode"
      [files]="fichiersNonConformes"
      [title]="fichiersNonConformesTitle"
      [titleColor]="'error'"
      [checkbox]="checkbox"
      (fileClicked)="onfileClick($event)">
    </app-file-status-accordion>
  }
  @if (fichiersNonConformesTraitees && fichiersNonConformesTraitees.length) {
    <app-file-status-accordion
      [audience]="mode"
      [files]="fichiersNonConformesTraitees"
      [title]="fichiersUpdatedTitle"
      [titleColor]="'transition'"
      [checkbox]="checkbox"
      (fileClicked)="onfileClick($event)">
    </app-file-status-accordion>
  }
  @if (fichiersConformes && fichiersConformes.length) {
    <app-file-status-accordion
      [audience]="mode"
      [files]="fichiersConformes"
      [title]="'Conformes'"
      [titleColor]="'valid'"
      [checkbox]="checkbox"
      (fileClicked)="onfileClick($event)">
    </app-file-status-accordion>
  }
</div>
